import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  methods: {
    async rincianTemuanTl(val, opsi) {
      const dataReport = await this.loadRincianTemuanTl(val, opsi);

      const dataShow = dataReport?.rowsDataLha?.map((data) => {
        return [
          {
            stack: [
              {
                text: data?.namaBidangObrik,
                fontSize: 14,
                colSpan: 4,
                bold: true,
              },
              {
                table: {
                  widths: [152, 152],
                  body: [
                    [
                      {
                        text: data?.nomorLha,
                        fontSize: 12,
                        bold: true,
                        border: [false, false, false, false],
                      },
                      {
                        text: data?.tanggalSaldo,
                        fontSize: 12,
                        bold: true,
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
              },
              {
                table: {
                  widths: [152, 152, 152, 152, 152],
                  body: [
                    [
                      {
                        text: data?.judulLaporan,
                        border: [false, false, false, false],
                      },
                      {
                        stack: [
                          {
                            text: data?.memoTemuan,
                          },
                          {
                            text: data?.kodeKelompokTemuan,
                            alignment: "right",
                            margin: [0, 5, 0, 5],
                          },
                          {
                            text: data?.kelompokTemuan,
                          },
                          {
                            text: data?.nilaiTemuan,
                            alignment: "right",
                            bold: true,
                            margin: [0, 5, 0, 0],
                          },
                        ],
                        border: [false, false, false, false],
                      },
                      {
                        stack: [
                          {
                            text: data?.memoPenyebab,
                          },
                        ],
                        border: [false, false, false, false],
                      },
                      {
                        stack: [
                          {
                            text: data?.memoRekomendasi,
                          },
                          {
                            text: data?.kodeKelompokRekomendasi,
                            alignment: "right",
                            margin: [0, 5, 0, 5],
                          },
                          {
                            text: data?.nilaiRekomendasi,
                            alignment: "right",
                            bold: true,
                          },
                        ],
                        border: [false, false, false, false],
                      },
                      {
                        stack: [
                          {
                            text: data?.memoTl,
                          },
                          {
                            text: data?.kodeSubKelompokTindakLanjut,
                            alignment: "right",
                            margin: [0, 5, 0, 5],
                          },
                          {
                            text: data?.nilaiTl,
                            alignment: "right",
                            bold: true,
                            margin: [0, 5, 0, 10],
                          },
                          {
                            text:
                              data?.statusTl !== ""
                                ? `Status TL : ${data?.statusTl}`
                                : "",
                            alignment: "right",
                            bold: true,
                          },
                        ],
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
              },
            ],
            colSpan: 4,
          },
          {},
          {},
          {},
          {},
        ];
      });

      const docDef = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [17, 85, 17, 30],

        header: [
          {
            text: localStorage.namaUnit,
            fontSize: 14,
            bold: true,
            margin: [17, 20, 0, 3],
          },
          {
            text: dataReport?.judul,
            fontSize: 13,
            margin: [17, 0, 0, 0],
          },
          {
            text:
              "Periode Pelaporan " + opsi.dateMulai.toLocaleDateString("id"),
            fontSize: 8,
            style: "headerPeriod",
            margin: [0, 0, 17, 3],
          },
          {
            text: "sd. " + opsi.dateSelesai.toLocaleDateString("id"),
            fontSize: 8,
            margin: [0, 0, 17, 7],
            style: "headerPeriod",
          },
        ],

        footer: function (currentPage, pageCount) {
          return {
            columns: [
              {
                text: "Tanggal Cetak : " + new Date().toLocaleString("id"),
                margin: [17, 0, 0, 0],
                fontSize: 7,
              },
              {
                text:
                  "halaman ke " + currentPage.toString() + " dari " + pageCount,
                alignment: "right",
                margin: [0, 0, 40, 0],
                fontSize: 7,
              },
            ],
          };
        },

        content: [
          {
            style: "tableExample",
            color: "#444",
            fontSize: 10,
            table: {
              widths: [150, 170, 150, 150, 150],
              headerRows: 1,
              // keepWithHeaderRows: 1,
              body: [
                [
                  {
                    text: "NOMOR LHA & TGL. LHA",
                    style: "tableHeader",
                    // border: [false, true, false, true],
                  },
                  {
                    text: "TEMUAN",
                    style: "tableHeader",
                    // border: [false, true, false, false],
                  },
                  {
                    text: "PENYEBAB",
                    style: "tableHeader",
                    // border: [false, true, false, true],
                  },
                  {
                    text: "REKOMENDASI",
                    style: "tableHeader",
                    // border: [false, true, false, false],
                  },
                  {
                    text: "TINDAK LANJUT",
                    style: "tableHeader",
                    // border: [false, true, false, false],
                  },
                ],
                ...dataShow,
              ],
            },

            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === 1 ? 1.5 : 0;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
              fillColor: function (rowIndex, node, columnIndex) {
                return rowIndex % 3 === 0 && rowIndex > 1 ? "#eeeeee" : null;
              },
              paddingTop: function (i, node) {
                return 4;
              },
              paddingBottom: function (i, node) {
                return 4;
              },
            },
          },
        ],
        styles: {
          headerPeriod: {
            alignment: "right",
          },
          tableHeader: {
            // alignment: "center",
            fontSize: 8,
          },
          tableSubHeader: {
            alignment: "left",
            fontSize: 8,
            bold: true,
          },
        },
      };

      pdfMake.createPdf(docDef).open();
    },

    async loadRincianTemuanTl(val, opsi) {
      try {
        const response = await axios({
          method: "GET",
          baseURL: this.$apiAddress,
          url: val.endpoint,
          params: {
            token: localStorage.getItem("api_token"),
            fromDate: opsi.dateMulai.toLocaleDateString("fr-CA"),
            toDate: opsi.dateSelesai.toLocaleDateString("fr-CA"),
          },
        });

        if (response.status == 200) {
          const responseData = await response.data;

          console.log("--> DATA REPORT RINCI");
          console.log(responseData);

          return responseData;
        }
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
